// src/components/layout/Sidebar.jsx
import { NavLink } from 'react-router-dom';
import { Home, Box as PixelIcon, Blocks as CRMIcon } from 'lucide-react';

const menuItems = [
  {
    name: 'Dashboard',
    path: '/',
    icon: Home,
  },
  {
    name: 'Pixels',
    path: '/pixels',
    icon: PixelIcon,
  },
  {
    name: 'CRM Integrations',
    path: '/integrations',
    icon: CRMIcon,
  },
];

export function Sidebar() {
  return (
    <div className="sl-sidebar fixed bottom-0 left-0 top-16 w-64 bg-white shadow-sm">
      <div className="sl-sidebar-content h-full">
        <nav className="sl-sidebar-nav px-4 py-6">
          <ul className="sl-nav-list space-y-4">
            {menuItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `sl-nav-item group flex items-center rounded-md px-3 py-2 text-sm font-medium ${
                      isActive
                        ? 'bg-primary-50 text-primary-600'
                        : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                    }`
                  }
                  end // Add end prop to ensure exact path matching for the root path
                >
                  <item.icon
                    className={`mr-3 h-5 w-5 flex-shrink-0`}
                    aria-hidden="true"
                  />
                  {item.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
}
